const defaultBrandModule = require("./brand_default");

//cache state
let configPromise = null;
let brandPromise = null;

const fetchConfig = async () => {
  if (!configPromise) {
    // In MFE mode, check for explicit brand override first.
    // This unifies MFE config.brand with gWhiteLabel so both CSS theming
    // and box style filtering use the same source of truth.
    if (typeof window !== "undefined" && window.__OC_MFE_BRAND__) {
      configPromise = Promise.resolve({ BRAND: window.__OC_MFE_BRAND__ });
      return configPromise;
    }
    // Otherwise fetch from backend. In MFE mode the host sets
    // window.__OC_MFE_API_BASE__ before importing so we fetch from
    // the backend origin instead of the CDN (which would 403).
    var baseUrl = (typeof window !== "undefined" && window.__OC_MFE_API_BASE__) || "";
    configPromise = fetch(baseUrl + "/whitelabel")
      .then(response => response.json())
      .catch(() => {
        return { BRAND: "default" };
      });
  }
  return configPromise;
};

const loadBrandModule = async () => {
  if (!brandPromise) {
    brandPromise = fetchConfig().then(async config => {
      const brand = config.BRAND || "default";
      if (brand === "default") {
        return defaultBrandModule;
      }
      try {
        const brandModule = await import(`./brand_${brand}`);
        return brandModule;
      } catch (error) {
        return defaultBrandModule;
      }
    });
  }
  return brandPromise;
};

let brandConfig = { ...defaultBrandModule };

// brandModulePromise -> loadBrandModule() is deferred until first access.
// In MFE mode, mount() sets window.__OC_MFE_BRAND__ and __OC_MFE_API_BASE__
// before calling initializeCore(), which triggers the first read of
// brandModulePromise. This ensures fetchConfig() sees the correct globals
const proxyHandler = {
  get: function (target, prop) {
    if (prop === "brandModulePromise") {
      if (!target.brandModulePromise) {
        const p = loadBrandModule();
        target.brandModulePromise = p;
        p.then(module => Object.assign(target, module));
      }
      return target.brandModulePromise;
    }
    return prop in target ? target[prop] : undefined;
  }
};

const brandConfigProxy = new Proxy(brandConfig, proxyHandler);
module.exports = brandConfigProxy;
